import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "../../return-to-checkout-modal.module.css";
import { ModalState } from "../../return-to-checkout-modal.types";
import { VehicleInformation } from "../../vehicle-information/vehicle-information.component";
import { Secondary, Text } from "@cinch-labs/design-system";
import React, { useEffect } from "react";
export var ReturnToCheckoutExpiredUnavailable = function(param) {
    var i18n = param.i18n, vehicle = param.vehicle, onButtonClick = param.onButtonClick, title = param.title, isButtonLoading = param.isButtonLoading, adminFeeFlag = param.adminFeeFlag, adminFeeValueInPence = param.adminFeeValueInPence, noOpTracking = param.noOpTracking, trackEvent = param.trackEvent, onModalOpen = param.onModalOpen;
    useEffect(function() {
        onModalOpen(ModalState.expiredUnavailable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.contentWrapper,
        children: [
            title,
            /*#__PURE__*/ _jsx(VehicleInformation, {
                vehicle: vehicle,
                hidePrice: true,
                grayscale: true,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.expiredUnavailableText,
                fontWeight: "light",
                fontSize: "s",
                children: i18n.text
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                isLoading: isButtonLoading,
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            })
        ]
    });
};
